import * as tslib_1 from "tslib";
import { Type } from 'class-transformer';
const ɵ0 = () => Date;
export class CommunitySelectorResultDto {
    get isTerminating() {
        // Could not use Utils. As the expected output differs.
        return this.terminatingDate ? true : false;
    }
    get context() {
        return `C${this.communityId}`;
    }
    get isActive() {
        return this.status !== 'Terminated';
    }
    get displayText() {
        return `${this.communityName}; ${this.locationName}; ${this.status}`;
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", Date)
], CommunitySelectorResultDto.prototype, "terminatingDate", void 0);
export { ɵ0 };
